import { EnumIVA, EnumOrigen } from "../settings/enumConfig";
import {
    apiEmpresaCreateEmpresa,
    apiEmpresaGetEmpresas,
    apiFolioCreateFolioEmpresa,
    apiFolioDeleteFolioEmpresa,
    apiFolioGenerarFolioArchivo,
    apiFolioGetFolioVentaCallePlantilla,
    apiFolioGetReport,
    apiFolioUpdateFechaVencimiento,
    apiFolioVerificarArchivo,
    apiProductoGetObtenerProducto,
} from "../settings/apiConfig";
import { createContext, useContext, useEffect, useState } from "react";
import { fnHandleChangeDate, fnHandleChangeText } from "../settings/handleConfig";
import { fnPrevent, fnPreventBlur } from "../settings/preventConfig";
import {
    getFormCargarArchivo,
    getFormEmpresa,
    getFormFiltroFolios,
    getFormVigencia,
    getModelEmpresa,
} from "../models/EmpresaModel";
import { green, red } from "@material-ui/core/colors";

import { rxCorreo } from "../settings/regexConfig";
import { useLayout } from "./LayoutContext";
import { useLogin } from "./LoginContext";
import { useRequest } from "./RequestContext";

export const EmpresaContext = createContext();

export function EmpresaProvider(props) {
    const { handleOpenAlert } = useLayout();
    const { usuarioSesion } = useLogin();
    const { Get, GetFile, Post, PostFile } = useRequest();

    const [listaEmpresas, setListaEmpresas] = useState([]);
    const [listaProductos, setListaProductos] = useState([]);
    const [listaProductosSeleccionar, setListaProductosSeleccionar] = useState([]);
    const [listaProductosSeleccionados, setListaProductosSeleccionados] = useState([]);
    const [listaFolios, setListaFolios] = useState([]);
    const [listaFoliosArchivoVerificado, setListaFoliosArchivoVerificado] = useState(null);
    const [triggerListaFolios, setTriggerListaFolios] = useState(false);
    const [triggerListaProductosSeleccionar, setTriggerListaProductosSeleccionar] = useState(false);
    const [empresaSeleccionada, setEmpresaSeleccionada] = useState(getModelEmpresa());
    const [foliosSeleccionados, setFoliosSeleccionados] = useState([]);
    const [subtotal, setSubtotal] = useState(0);
    const [montoIva, setMontoIva] = useState(0);
    const [archivoCargadoFolios, setArchivoCargadoFolios] = useState(null);

    const [modalOpenFormEmpresa, setModalOpenFormEmpresa] = useState(false);
    const [modalOpenAdministrarEmpresa, setModalOpenAdministrarEmpresa] = useState(false);
    const [modalOpenAgregarFolios, setModalOpenAgregarFolios] = useState(false);
    const [modalOpenModificarVigencia, setModalOpenModificarVigencia] = useState(false);
    const [modalOpenSubirArchivo, setModalOpenSubirArchivo] = useState(false);
    const [modalOpenEliminarFolios, setModalOpenEliminarFolios] = useState(false);
    const [modalOpenResumenAgregarFolios, setModalOpenResumenAgregarFolios] = useState(false);
    const [modalOpenDetalleArchivoVerificado, setModalOpenDetalleArchivoVerificado] = useState(false);

    const [formEmpresa, setFormEmpresa] = useState(getFormEmpresa());
    const [formFiltroFolios, setFormFiltroFolios] = useState(getFormFiltroFolios());
    const [formVigencia, setFormVigencia] = useState(getFormVigencia());
    const [formCargarArchivo, setFormCargarArchivo] = useState(getFormCargarArchivo());

    const handleOpenFormEmpresa = (value) => {
        setModalOpenFormEmpresa(value);
    };

    const handleOpenAdministrarEmpresa = (value) => {
        setModalOpenAdministrarEmpresa(value);
    };

    const handleOpenAgregarFolios = (value) => {
        setModalOpenAgregarFolios(value);
    };

    const handleOpenModificarVigencia = (value) => {
        setModalOpenModificarVigencia(value);
    };

    const handleOpenSubirArchivo = (value) => {
        setModalOpenSubirArchivo(value);
    };

    const handleOpenEliminarFolios = (value) => {
        setModalOpenEliminarFolios(value);
    };

    const handleOpenResumenAgregarFolios = (value) => {
        setModalOpenResumenAgregarFolios(value);
    };

    const handleOpenDetalleArchivoVerificado = (value) => {
        setModalOpenDetalleArchivoVerificado(value);
    };

    const handleChangeListaFolios = (value) => {
        setListaFolios(value);
    };

    const handleChangeFoliosSeleccionados = (value) => {
        setFoliosSeleccionados(value);
    };

    const handleChangeListaProductosSeleccionar = (value) => {
        setListaProductosSeleccionar(value);
    };

    const handleChangeListaProductosSeleccionados = (value) => {
        setListaProductosSeleccionados(value);
    };

    const handleChangeSubtotal = (value) => {
        setSubtotal(value);
    };

    const handleChangeMontoIva = (value) => {
        setMontoIva(value);
    };

    const handleChangeEmpresaSeleccionada = (value) => {
        setEmpresaSeleccionada(value);
    };

    const handleChangeFormEmpresa = fnHandleChangeText(formEmpresa, setFormEmpresa);
    const handleChangeFormFiltroFolios = fnHandleChangeText(formFiltroFolios, setFormFiltroFolios);
    const handleChangeVigencia = fnHandleChangeDate(formVigencia, setFormVigencia);
    const handleChangeCargarArchivo = fnHandleChangeText(formCargarArchivo, setFormCargarArchivo);

    const handleClickNuevaEmpresa = () => {
        const empresa = getModelEmpresa();
        setEmpresaSeleccionada(empresa);
        fnFillFormEmpresa(empresa);
        setModalOpenFormEmpresa(true);
    };

    const handleClickEditarEmpresa = () => {
        if (empresaSeleccionada.iIdEmpresa === 0) {
            handleOpenAlert("Seleccione una empresa para editar");
            return;
        }
        fnFillFormEmpresa(empresaSeleccionada);
        setModalOpenFormEmpresa(true);
    };

    const handleClickAdministrarEmpresa = async () => {
        if (empresaSeleccionada.iIdEmpresa === 0) {
            handleOpenAlert("Seleccione una empresa para administrar");
            return;
        }
        setFormFiltroFolios(getFormFiltroFolios());
        setListaProductosSeleccionados([]);
        setFoliosSeleccionados([]);
        await fnObtenerFolios(null, empresaSeleccionada.iIdEmpresa);
        setModalOpenAdministrarEmpresa(true);
    };

    const handleClickRefrescarDatos = async () => {
        await fnObtenerProductos();
        await fnObtenerEmpresas();
    };

    const handleClickAgregarFolios = () => {
        setModalOpenAgregarFolios(true);
        fnLimpiarProductosSeleccionar();
        setListaProductosSeleccionados([]);
    };

    const handleClickModificarVigencia = () => {
        if (foliosSeleccionados.length < 1) {
            handleOpenAlert("Seleccione los folios para modificar la vigencia");
            return;
        }
        setFormVigencia(getFormVigencia());
        setModalOpenModificarVigencia(true);
    };

    const handleClickSubirArchivo = () => {
        setArchivoCargadoFolios(null);
        setListaFoliosArchivoVerificado(null);
        setFormCargarArchivo(getFormCargarArchivo());
        setModalOpenSubirArchivo(true);
    };

    const handleClickDescargarPlantilla = () => {
        fnDescargarPlantilla();
    };

    const handleClickEliminarFolios = () => {
        if (foliosSeleccionados.length < 1) {
            handleOpenAlert("Seleccione los folios para eliminar");
            return;
        }
        setModalOpenEliminarFolios(true);
    };

    const handleClickRefrescarDatosFolios = async () => {
        await fnObtenerFolios(null, empresaSeleccionada.iIdEmpresa);
        setFormFiltroFolios(getFormFiltroFolios());
        setFoliosSeleccionados([]);
    };

    const handleClickFiltrarFolios = () => {
        const { txtOrigen, txtProducto, txtVigente } = formFiltroFolios;
        const iIdEmpresa = empresaSeleccionada.iIdEmpresa;

        fnObtenerFolios(
            null,
            iIdEmpresa,
            txtProducto.value,
            txtOrigen.value,
            "",
            "",
            null,
            true,
            false,
            txtVigente.value
        );
    };

    const handleClickCargarArchivo = () => {
        let input = document.createElement("input");
        input.type = "file";
        input.value = "";
        input.addEventListener("change", async () => {
            let archivo = input.files[0];
            if (!archivo) {
                handleOpenAlert("No se cargó ningún archivo");
                return;
            }

            if (
                archivo.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
                archivo.type !== "application/vnd.ms-excel"
            ) {
                handleOpenAlert("El formato del archivo debe ser .xls o .xlsx");
                return;
            }

            const { txtArchivoFolios } = formCargarArchivo;

            setArchivoCargadoFolios(archivo);
            setListaFoliosArchivoVerificado(null);
            setFormCargarArchivo({
                ...formCargarArchivo,
                txtArchivoFolios: {
                    ...txtArchivoFolios,
                    value: archivo.name,
                    error: false,
                },
            });
        });
        input.click();
        input.remove();
    };

    const handleClickVerificarArchivoFolios = () => {
        const formValidado = fnValidarFormCargarArchivo();
        if (!formValidado) return;

        const { txtProducto } = formCargarArchivo;
        fnVerificarArchivo(empresaSeleccionada.iIdEmpresa, txtProducto.value, archivoCargadoFolios);
    };

    const handleClickLimpiarArchivo = () => {
        setArchivoCargadoFolios(null);
        setListaFoliosArchivoVerificado(null);
        const { txtArchivoFolios } = formCargarArchivo;
        setFormCargarArchivo({
            ...formCargarArchivo,
            txtArchivoFolios: { ...txtArchivoFolios, value: "" },
        });
    };

    const handleClickDetalleFolioVerificado = () => {
        setModalOpenSubirArchivo(false);
        setModalOpenDetalleArchivoVerificado(true);
    };

    const handleClickRegresar = () => {
        setModalOpenDetalleArchivoVerificado(false);
        setModalOpenSubirArchivo(true);
    };

    const handleCloseAgregarFolios = () => {
        setModalOpenAgregarFolios(true);
        setModalOpenResumenAgregarFolios(false);
    };

    const handleSubmitAgregarFolios = () => {
        if (listaProductosSeleccionados.length < 1) {
            handleOpenAlert(
                "Para generar los folios debe seleccionar al menos un producto de la lista e ingresar la cantidad (mínimo 1).",
                "warning"
            );
            return;
        }
        if (listaProductosSeleccionados.some((x) => isNaN(x.iCantidad) || x.iCantidad === 0 || x.iCantidad === "")) {
            handleOpenAlert(
                "Verifique que las cantidades ingresadas para los productos seleccionados sean como mínimo 1.",
                "warning"
            );
            return;
        }

        setModalOpenResumenAgregarFolios(true);
        setModalOpenAgregarFolios(false);
    };

    const handleSubmitVerificarArchivo = (e) => {
        fnPrevent(e);
        handleClickDetalleFolioVerificado();
    };

    const handleSubmitCargarArchivo = () => {
        const formValidado = fnValidarFormCargarArchivo();
        if (!formValidado) return;

        const { txtProducto } = formCargarArchivo;

        fnGuardarFoliosArchivo(
            empresaSeleccionada.iIdEmpresa,
            txtProducto.value,
            usuarioSesion.iIdUsuario,
            archivoCargadoFolios
        );
    };

    const handleSubmitEliminarFolios = () => {
        const entFolioFVSubmit = {
            iIdEmpresa: empresaSeleccionada.iIdEmpresa,
            iIdUsuario: usuarioSesion.iIdUsuario,
            lstFolios: foliosSeleccionados.map((folio) => ({
                iIdFolio: folio.iIdFolio,
            })),
        };
        fnEliminarFoliosEmpresa(entFolioFVSubmit);
    };

    const handleSubmitFormEmpresa = (e) => {
        fnPrevent(e);

        const { txtNombreEmpresa, txtCorreoEmpresa } = formEmpresa;

        const form = {
            ...formEmpresa,
            txtNombreEmpresa: {
                ...txtNombreEmpresa,
                error: txtNombreEmpresa.value === "",
            },
            txtCorreoEmpresa: {
                ...txtCorreoEmpresa,
                error: !rxCorreo.test(txtCorreoEmpresa.value),
            },
        };

        setFormEmpresa(form);
        if (
            Object.values(form)
                .map((x) => x.error)
                .includes(true)
        ) {
            return;
        }

        const entEmpresa = {
            iIdEmpresa: empresaSeleccionada.iIdEmpresa,
            sNombre: txtNombreEmpresa.value,
            sCorreo: txtCorreoEmpresa.value,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            bActivo: true,
            bBaja: false,
        };

        fnGuardarEmpresa(entEmpresa);
    };

    const handleSubmitModificarVigencia = (e) => {
        fnPrevent(e);

        const { dtpFechaVigencia } = formVigencia;
        const form = {
            ...formVigencia,
            dtpFechaVigencia: { ...dtpFechaVigencia, error: !dtpFechaVigencia.value },
        };
        setFormVigencia(form);
        if (
            Object.values(form)
                .map((x) => x.error)
                .includes(true)
        ) {
            return;
        }

        const entVigencias = {
            iIdEmpresa: empresaSeleccionada.iIdEmpresa,
            iIdUsuario: usuarioSesion.iIdUsuario,
            dtFechaVencimiento: dtpFechaVigencia.value.toLocaleString(),
            lstFolios: foliosSeleccionados.map((folio) => ({
                iIdFolio: folio.iIdFolio,
            })),
        };

        fnModificarVigencias(entVigencias);
    };

    const handleSubmitGenerarFolios = () => {
        const entFoliosEmpresa = {
            iIdEmpresa: empresaSeleccionada.iIdEmpresa,
            iIdOrigen: EnumOrigen.PanelAdministrativo,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            line_items: listaProductosSeleccionados.map((prod) => ({
                product_id: prod.iIdProducto,
                quantity: prod.iCantidad,
            })),
        };
        fnGuardarFoliosEmpresa(entFoliosEmpresa);
    };

    const fnFillFormEmpresa = (empresa) => {
        const { txtFolioEmpresa, txtNombreEmpresa, txtCorreoEmpresa } = getFormEmpresa();

        setFormEmpresa({
            ...formEmpresa,
            txtFolioEmpresa: {
                ...txtFolioEmpresa,
                value: !empresa.sFolioEmpresa ? "" : empresa.sFolioEmpresa,
            },
            txtNombreEmpresa: {
                ...txtNombreEmpresa,
                value: !empresa.sNombre ? "" : empresa.sNombre,
            },
            txtCorreoEmpresa: {
                ...txtCorreoEmpresa,
                value: !empresa.sCorreo ? "" : empresa.sCorreo,
            },
        });
    };

    const fnLimpiarProductosSeleccionar = () => {
        setListaProductosSeleccionar(
            listaProductos.map((producto) => ({
                iIdProducto: producto.iIdProducto,
                sNombre: producto.sNombre,
                fCosto: producto.fCosto,
                sCosto: producto.sCosto,
                iCantidad: 0,
                sIconStatus: (
                    <span>
                        <i
                            className="icon size-20 color-1"
                            dangerouslySetInnerHTML={{ __html: `&#x${producto.sIcon}` }}
                        />
                    </span>
                ),
            }))
        );
        setTriggerListaProductosSeleccionar(!triggerListaProductosSeleccionar);
    };

    const fnValidarFormCargarArchivo = () => {
        const { txtProducto, txtArchivoFolios } = formCargarArchivo;
        const formValidado = {
            ...formCargarArchivo,
            txtProducto: { ...txtProducto, error: txtProducto.value === "" },
            txtArchivoFolios: {
                ...txtArchivoFolios,
                error: txtArchivoFolios.value === "" || !archivoCargadoFolios,
            },
        };

        setFormCargarArchivo(formValidado);

        return !Object.values(formValidado)
            .map((x) => x.error)
            .some((x) => x);
    };

    const fnObtenerEmpresas = async (iIdEmpresa = null) => {
        const payload = {
            loader: "Consultando empresas...",
            url: apiEmpresaGetEmpresas + "?iIdEmpresa=" + iIdEmpresa,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setListaEmpresas(response.Result);
        }
    };

    const fnObtenerProductos = async (iIdProducto = null) => {
        const payload = {
            loader: "Consultando productos...",
            url: apiProductoGetObtenerProducto + "?iIdProducto=" + iIdProducto,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setListaProductos(response.Result.filter((x) => x.sIdPlan == "" || x.sIdPlan == null));
        }
    };

    const fnGuardarEmpresa = async (entEmpresa) => {
        const payload = {
            loader: "Guardando empresa...",
            url: apiEmpresaCreateEmpresa,
            body: entEmpresa,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenFormEmpresa(false);
            setEmpresaSeleccionada(entEmpresa);
            await fnObtenerEmpresas();
        }
        fnPreventBlur();
    };

    const fnObtenerFolios = async (
        piIdFolio = "",
        piIdEmpresa = "",
        piIdProducto = "",
        piIdOrigen = "",
        psFolio = "",
        psOrdenConekta = "",
        pbTerminosYCondiciones = "",
        pbActivo = true,
        pbBaja = false,
        pbVigente = ""
    ) => {
        const payload = {
            loader: "Consultando folios de empresa...",
            url:
                apiFolioGetReport +
                "?piIdFolio=" +
                piIdFolio +
                "&piIdEmpresa=" +
                piIdEmpresa +
                "&piIdProducto=" +
                piIdProducto +
                "&piIdOrigen=" +
                piIdOrigen +
                "&psFolio=" +
                psFolio +
                "&psOrdenConekta=" +
                psOrdenConekta +
                "&pbTerminosYCondiciones=" +
                pbTerminosYCondiciones +
                "&pbActivo=" +
                pbActivo +
                "&pbBaja=" +
                pbBaja +
                "&pbVigente=" +
                pbVigente,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setListaFolios(
                response.Result.map((folio) => ({
                    ...folio,
                    sStatus: (
                        <span>
                            <i
                                className="icon size-20"
                                style={{
                                    color: folio.bVigente === true ? green[500] : red[500],
                                    verticalAlign: "middle",
                                }}
                                dangerouslySetInnerHTML={{ __html: `&#x${folio.sIcon}` }}
                            />
                        </span>
                    ),
                }))
            );
            setTriggerListaFolios(!triggerListaFolios);
        }
    };

    const fnDescargarPlantilla = async () => {
        const payload = {
            loader: "Descargando plantilla...",
            url: apiFolioGetFolioVentaCallePlantilla,
            filename: "plantila-folio.xlsx",
            alert: false,
        };

        await GetFile(payload);
    };

    const fnEliminarFoliosEmpresa = async (entFolios) => {
        const payload = {
            loader: "Eliminando folios seleccionados...",
            url: apiFolioDeleteFolioEmpresa,
            body: entFolios,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenEliminarFolios(false);
            setFoliosSeleccionados([]);
            await fnObtenerFolios(null, empresaSeleccionada.iIdEmpresa);
            setFormFiltroFolios(getFormFiltroFolios());
        }
    };

    const fnGuardarFoliosEmpresa = async (entFoliosEmpresa) => {
        const payload = {
            loader: "Generando folios...",
            url: apiFolioCreateFolioEmpresa,
            body: entFoliosEmpresa,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenAgregarFolios(false);
            setModalOpenResumenAgregarFolios(false);
            fnLimpiarProductosSeleccionar();
            setListaProductosSeleccionados([]);
            setFoliosSeleccionados([]);
            await fnObtenerFolios(null, empresaSeleccionada.iIdEmpresa);
            setFormFiltroFolios(getFormFiltroFolios());
        }
    };

    const fnModificarVigencias = async (entVigencias) => {
        const payload = {
            loader: "Modificando vigencias...",
            url: apiFolioUpdateFechaVencimiento,
            body: entVigencias,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenModificarVigencia(false);
            setFormVigencia(getFormVigencia());
            setFoliosSeleccionados([]);
            await fnObtenerFolios(null, empresaSeleccionada.iIdEmpresa);
            setFormFiltroFolios(getFormFiltroFolios());
        }
    };

    const fnVerificarArchivo = async (piIdEmpresa, piIdProducto, archivo) => {
        const payload = {
            loader: "Verificando archivo...",
            url: apiFolioVerificarArchivo + "?piIdEmpresa=" + piIdEmpresa + "&piIdProducto=" + piIdProducto,
            file: archivo,
            alert: true,
        };

        const response = await PostFile(payload);
        if (response.Code === 0) {
            setListaFoliosArchivoVerificado(response.Result);
        }
    };

    const fnGuardarFoliosArchivo = async (piIdEmpresa, piIdProducto, piIdUsuarioMod, archivo) => {
        const payload = {
            loader: "Generando folios...",
            url:
                apiFolioGenerarFolioArchivo +
                "?piIdEmpresa=" +
                piIdEmpresa +
                "&piIdProducto=" +
                piIdProducto +
                "&piIdUsuarioMod=" +
                piIdUsuarioMod,
            file: archivo,
            alert: true,
        };

        const response = await PostFile(payload);
        if (response.Code === 0) {
            setModalOpenSubirArchivo(false);
            setFormCargarArchivo(getFormCargarArchivo());
            setArchivoCargadoFolios(null);
            setListaFoliosArchivoVerificado(null);
            setFoliosSeleccionados([]);
            await fnObtenerFolios(null, empresaSeleccionada.iIdEmpresa);
            setFormFiltroFolios(getFormFiltroFolios());
        }
    };

    useEffect(() => {
        const calcSubtotal = listaProductosSeleccionados.reduce(
            (a, b) => a + (isNaN(b.iCantidad) ? 0 : b.iCantidad) * b.fCosto,
            0
        );

        const calcMontoIva = calcSubtotal * EnumIVA.IVA;

        setSubtotal(calcSubtotal);
        setMontoIva(calcMontoIva);
        // eslint-disable-next-line
    }, [listaProductosSeleccionar, listaProductosSeleccionados]);

    return (
        <EmpresaContext.Provider
            value={{
                listaEmpresas,
                listaProductos,
                listaProductosSeleccionar,
                listaProductosSeleccionados,
                listaFolios,
                listaFoliosArchivoVerificado,
                triggerListaFolios,
                triggerListaProductosSeleccionar,
                empresaSeleccionada,
                foliosSeleccionados,
                subtotal,
                montoIva,
                archivoCargadoFolios,
                modalOpenFormEmpresa,
                modalOpenAdministrarEmpresa,
                modalOpenAgregarFolios,
                modalOpenModificarVigencia,
                modalOpenSubirArchivo,
                modalOpenEliminarFolios,
                modalOpenResumenAgregarFolios,
                modalOpenDetalleArchivoVerificado,
                formEmpresa,
                formFiltroFolios,
                formVigencia,
                formCargarArchivo,
                handleOpenFormEmpresa,
                handleOpenAdministrarEmpresa,
                handleOpenAgregarFolios,
                handleOpenModificarVigencia,
                handleOpenSubirArchivo,
                handleOpenEliminarFolios,
                handleOpenResumenAgregarFolios,
                handleOpenDetalleArchivoVerificado,
                handleChangeListaFolios,
                handleChangeFoliosSeleccionados,
                handleChangeListaProductosSeleccionar,
                handleChangeListaProductosSeleccionados,
                handleChangeSubtotal,
                handleChangeMontoIva,
                handleChangeEmpresaSeleccionada,
                handleChangeFormEmpresa,
                handleChangeFormFiltroFolios,
                handleChangeVigencia,
                handleChangeCargarArchivo,
                handleCloseAgregarFolios,
                handleClickNuevaEmpresa,
                handleClickEditarEmpresa,
                handleClickAdministrarEmpresa,
                handleClickRefrescarDatos,
                handleClickAgregarFolios,
                handleClickModificarVigencia,
                handleClickSubirArchivo,
                handleClickDescargarPlantilla,
                handleClickEliminarFolios,
                handleClickRefrescarDatosFolios,
                handleClickFiltrarFolios,
                handleClickCargarArchivo,
                handleClickVerificarArchivoFolios,
                handleClickLimpiarArchivo,
                handleClickDetalleFolioVerificado,
                handleClickRegresar,
                handleSubmitAgregarFolios,
                handleSubmitVerificarArchivo,
                handleSubmitCargarArchivo,
                handleSubmitEliminarFolios,
                handleSubmitFormEmpresa,
                handleSubmitModificarVigencia,
                handleSubmitGenerarFolios,
            }}
        >
            {props.children}
        </EmpresaContext.Provider>
    );
}

export function useEmpresa() {
    return useContext(EmpresaContext);
}
